<script lang="ts">
    import { debounce } from "@app/utils/debounce";
    import { activateSearchWidget, setSearchPhrase } from "../Search.store";
    import { initWordlistLoader } from "../SearchService";
    import { generatePhraseUrlForCurrentDictionary } from "@app/services/url-builder.service";
    import { dictionary } from "@app/services/currentDictionary.service";
    import { SEARCH__searchBoxPlaceholder } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { isMobile } from "@app/services/isMobile";

    export let dictionarySearchInput: HTMLInputElement;
    export let searchWidgetContainer: HTMLElement;

    async function dictionarySearchInputChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        setSearchPhrase(value.trim());
    }

    if (dictionarySearchInput && searchWidgetContainer) {
        dictionarySearchInput.addEventListener(
            "input",
            debounce(350, dictionarySearchInputChange),
        );
        dictionarySearchInput.addEventListener("input", activateSearchWidget);
        dictionarySearchInput.addEventListener("click", activateSearchWidget);

        if (!isMobile() && document.getElementById("force-wordlist-reload")) {
            initWordlistLoader(false);
        } else {
            initWordlistLoader(true);
        }
        setSearchPhrase(dictionarySearchInput.value.trim());
    }

    function attachOnSubmitToSearchForm() {
        if (!searchWidgetContainer) {
            return;
        }
        const form =
            searchWidgetContainer.querySelector<HTMLFormElement>("form");
        if (!form) {
            return;
        }
        const queryInput =
            form.querySelector<HTMLInputElement>("input[name=q]");

        if (!queryInput) {
            return;
        }

        form.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = generatePhraseUrlForCurrentDictionary(
                queryInput.value.trim(),
            );
        });
    }

    function updateInputPlaceholderOnQueryChange() {
        if (!searchWidgetContainer) {
            return;
        }
        const form =
            searchWidgetContainer.querySelector<HTMLFormElement>("form");
        if (!form) {
            return;
        }
        const queryInput =
            form.querySelector<HTMLInputElement>("input[name=q]");
        const prevDictionary = $dictionary;
        dictionary.subscribe((newDictionary) => {
            if (prevDictionary != newDictionary) {
                queryInput!.placeholder = getMessage(
                    SEARCH__searchBoxPlaceholder,
                    [
                        newDictionary.l1.nameForDictionarySource ||
                            newDictionary.l1.name,
                        newDictionary.l2.name,
                    ],
                );
            }
        });
    }
    attachOnSubmitToSearchForm();
    updateInputPlaceholderOnQueryChange();
</script>
